import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

import LoginForm from './components/LoginForm';
import SignUpForm from './components/SignUpForm';
import GoogleAuthButton from './components/GoogleAuthButton';

const Authentication = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('login');

  const handleAuthSuccess = (userData) => {
    console.log('Authentication successful:', userData);
    navigate('/user-dashboard');
  };

  const handleClose = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/5 flex items-center justify-center p-[16px] lg:p-[24px]">
      {/* Modal Container */}
      <div className="w-full max-w-[480px] bg-card rounded-xl shadow-warm-lg border border-border overflow-hidden">
        {/* Header */}
        <div className="relative bg-gradient-to-r from-primary to-secondary p-[24px] lg:p-[30px] text-center">
          <button
            onClick={handleClose}
            className="absolute top-[16px] right-[16px] p-[8px] rounded-md hover:bg-white/10 transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} color="#FFFFFF" />
          </button>
          
          <div className="flex justify-center mb-[12px]">
            <div className="w-[48px] h-[48px] bg-white/20 rounded-lg flex items-center justify-center">
              <Icon name="Zap" size={28} color="#FFFFFF" />
            </div>
          </div>
          
          <h1 className="text-[24px] lg:text-[28px] font-heading font-bold text-white mb-[8px]">
            Welcome to DISKARTE
          </h1>
          <p className="text-white/90 text-[14px] lg:text-[15px] font-body">
            Unlock opportunities for Filipino workers
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="flex border-b border-border bg-muted/30">
          <button
            onClick={() => setActiveTab('login')}
            className={`flex-1 py-[16px] text-[15px] font-medium transition-smooth relative ${
              activeTab === 'login' ?'text-primary bg-background' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
            }`}
          >
            Log In
            {activeTab === 'login' && (
              <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-primary rounded-t-sm" />
            )}
          </button>
          <button
            onClick={() => setActiveTab('signup')}
            className={`flex-1 py-[16px] text-[15px] font-medium transition-smooth relative ${
              activeTab === 'signup' ?'text-primary bg-background' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
            }`}
          >
            Sign Up
            {activeTab === 'signup' && (
              <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-primary rounded-t-sm" />
            )}
          </button>
        </div>

        {/* Content Area */}
        <div className="p-[24px] lg:p-[30px]">
          {/* Google OAuth Button */}
          <GoogleAuthButton onSuccess={handleAuthSuccess} />

          {/* Divider */}
          <div className="flex items-center gap-[12px] my-[24px]">
            <div className="flex-1 h-[1px] bg-border" />
            <span className="text-[13px] text-muted-foreground font-medium">OR</span>
            <div className="flex-1 h-[1px] bg-border" />
          </div>

          {/* Forms */}
          {activeTab === 'login' ? (
            <LoginForm onSuccess={handleAuthSuccess} />
          ) : (
            <SignUpForm onSuccess={handleAuthSuccess} />
          )}
        </div>

        {/* Footer */}
        <div className="px-[24px] lg:px-[30px] pb-[24px] lg:pb-[30px] text-center">
          <p className="text-[13px] text-muted-foreground">
            By continuing, you agree to DISKARTE's{' '}
            <a href="#" className="text-primary hover:underline">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="#" className="text-primary hover:underline">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>

      {/* Background Illustration */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-[10%] right-[5%] w-[200px] h-[200px] bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[15%] left-[10%] w-[250px] h-[250px] bg-secondary/5 rounded-full blur-3xl" />
      </div>
    </div>
  );
};

export default Authentication;